import React from 'react'
import {FormattedMessage, useIntl} from 'react-intl'
import Typography from '@material-ui/core/Typography'
import Layout from '../../layouts/WelcomePageLayout'
import ForgotPasswordForm from '../../organisms/login/ForgotPasswordForm'
import Auth from 'lib/auth'
import ForgotPasswordConfirmationForm from '../../organisms/login/ForgotPasswordConfirmationForm'
import {FormHelperText, Link} from '@material-ui/core'
import {Link as RouterLink} from 'react-router-dom'

const Header = ({className}) => (
  <Typography variant="h5" component="h1" className={className}>
    <FormattedMessage id="forgotPassword.text" />
  </Typography>
)

export default function ForgotPasswordPage() {
  const intl = useIntl()
  const [view, setView] = React.useState('enterEmail')
  const [isLoading, setIsLoading] = React.useState(false)
  const [errorMessage, setErrorMessage] = React.useState(null)
  const [username, setUsername] = React.useState(null)

  const handleSubmit = async values => {
    setIsLoading(true)
    const result = await Auth.forgotPassword(values.username)
    result.matchWith({
      Ok: async () => {
        setUsername(values.username)
        setView('confirmCode')
      },
      Error: ({value}) => {
        setErrorMessage(value.message)
      },
    })
    setIsLoading(false)
  }

  const handleConfirmation = async (values) => {
    setIsLoading(true)
    const result = await Auth.forgotPasswordSubmit(values.username, values.confirmationCode, values.newPassword)
    result.matchWith({
      Ok: async () => {
        setView('success')
      },
      Error: ({value}) => {
        setErrorMessage(value.message)
      },
    })
    setIsLoading(false)
  }

  if (view === 'enterEmail') {
    return (
      <Layout header={Header}>
        <Typography variant="subtitle1">
          <FormattedMessage id="forgotPassword.helpText" />
        </Typography>
        {errorMessage && (
          <FormHelperText error>
            {intl.formatMessage({id: `login.errors.forgotPassword.${errorMessage}`})}
          </FormHelperText>
        )}
        <ForgotPasswordForm handleSubmit={handleSubmit} isSubmitting={isLoading} />
      </Layout>
    )
  }

  if (view === 'confirmCode') {
    return (
      <Layout header={Header}>
        <Typography variant="subtitle1">
          <FormattedMessage id="forgotPassword.confirmCodeHelp" />
        </Typography>
        {errorMessage && (
          <FormHelperText error>
            {intl.formatMessage({id: `login.errors.forgotPassword.${errorMessage}`})}
          </FormHelperText>
        )}
        <ForgotPasswordConfirmationForm
          username={username}
          handleSubmit={handleConfirmation}
          isSubmitting={isLoading}
        />
      </Layout>
    )
  }

  if (view === 'success') {
    return (
      <Layout header={Header}>
        <Typography variant="subtitle1">
          <FormattedMessage id="forgotPassword.success" />{' '}
          <Link to="/login" variant="subtitle1" component={RouterLink}>
            <FormattedMessage id="forgotPassword.signInLink" />
          </Link>
        </Typography>
      </Layout>
    )
  }
}
